export enum WecdevErrorMessageType {
    PROPERTY_ERROR = 'PROPERTY_ERROR',
    GUARD_ERROR = 'GUARD_ERROR',
}

export abstract class WecdevErrorMessage {
    public type?: WecdevErrorMessageType;
    public message?: string;
}

export class GuardErrorMessage extends WecdevErrorMessage {}

export class PropertyErrorMessage extends WecdevErrorMessage {
    public propertyName?: string;
}

export class ServerSideValidationError {
    public serverSideValidatorName: string;
    public params: any;
}
